import { useRedirectOnSuccess } from "@/src/mixins/useRedirectOnSuccess";
import { Controller } from "stimulus";
export default class extends Controller {

  connect() {
    useRedirectOnSuccess(this);
  }

}
